import {ComparisonOperatorMap} from "../domain/ComparisonOperatorMap";

export const buildFilterValueForFilterType = (model) => {
    if (model.operator === 'isAnyOf') {
        return model.value.join(',');
    } else if (model.value instanceof Date) {
        return model.value.toISOString();
    } else {
        return model.value;
    }
}

export const buildFilterCriterionFromModel = (model) => {
    return {
        field: model.field,
        operator: ComparisonOperatorMap[model.operator],
        value: buildFilterValueForFilterType(model)
    };
}

export const shouldIncludeInFilter = model => model.value
  || model.operator === 'isNotEmpty'
  || model.operator === 'isEmpty';